import type {
  MessagingProtectionApiResponse,
  MessagingProtectionResponse,
  MessagingReviewResponse,
} from '@/types/Api/MessagingProtection'
import type { AxiosItem } from '@/types/Components/Response'
import { protectionTimezone } from '@/const/MessagingProtection'
import { BaseProxy } from '@/proxies/Proxy'
import MessagingProtectionTransformer from '@/transformers/MessagingProtectionTransformer'

export default class MessagingProtectionProxy extends BaseProxy {
  public endpoint = 'deployment-protection'

  async all(): Promise<MessagingProtectionResponse> {
    this.parameters = { ...this.parameters, timezone: protectionTimezone }
    const { data } = await this.submit<AxiosItem<MessagingProtectionApiResponse>>('get', `/${this.endpoint}`)
    return MessagingProtectionTransformer.fetch(data)
  }

  async recheck(id: string, comment: string): Promise<MessagingReviewResponse> {
    const { data } = await this.submit<AxiosItem<MessagingReviewResponse>>('post', `/${this.endpoint}/${id}/review`, {
      action: 'recheck',
      comment,
    })
    return data
  }

  async cancel(id: string, comment: string): Promise<MessagingReviewResponse> {
    const { data } = await this.submit<AxiosItem<MessagingReviewResponse>>('post', `/${this.endpoint}/${id}/review`, {
      action: 'cancel',
      comment,
    })
    return data
  }
}
